import { mobileOnly } from '../platform';
export default mobileOnly(() => import('./mobile/Favourites'));
